// ===========================
// XHR Intercept: Inject _skus_v2 + _preset_skus into add.js
// ===========================
(function () {
    var _lastSelectedSkus = '';
    // Snapshot of the settled preset selection — what the SumTracker bundle of
    // this product deducts natively. Sent as _preset_skus so the inventory Flow
    // can compute the delta (deduct what was selected, restock what the preset
    // had) without a metafield.
    var _presetBaselineSkus = null;

    window._etSnapshotBaselineSkus = function () {
        if (_presetBaselineSkus === null) {
            _presetBaselineSkus = _lastSelectedSkus;
            console.log('[ET] Preset baseline SKUs snapshotted.\n Selected SKUs:', _presetBaselineSkus);
        }
    };

    window._etUpdateSkus = async function () {
        if (!window.expivi) return;
        var attrs = await window.expivi.getProductAttributes();
        _lastSelectedSkus = attrs
            .filter(function (a) {
                return a.type === 'question' && a.visible !== false
                    && a.attribute_values && a.attribute_values.length > 0;
            })
            .map(function (a) {
                const sel = a.attribute_values.find(v => v.id === a.selected_value_id);
                if (!sel?.key) return null;
                if (sel.key.startsWith('att-')) return null;
                return sel.key;
            })
            .filter(Boolean)
            .join(',');
    };

    window._etGetSelectedSkus = function () {
        return _lastSelectedSkus;
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
        this._etUrl = url;
        return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
        if (this._etUrl && this._etUrl.indexOf('add.js') !== -1 && body) {
            try {
                var data = JSON.parse(body);
                if (!data.properties) data.properties = {};
                // _skus_v2 (NOT _selected_skus): the live Flow matches keys by the
                // substring "_selected_skus", so this name keeps test orders from this
                // theme invisible to it; the new v2 Flow triggers on _skus_v2 only.
                data.properties['_skus_v2'] = _lastSelectedSkus;
                data.properties['_preset_skus'] = _presetBaselineSkus || '';
                body = JSON.stringify(data);
                console.log('[ET] Injected into add.js — _skus_v2:', _lastSelectedSkus, '_preset_skus:', _presetBaselineSkus || '');
            } catch (e) {
                console.log('[ET] add.js body is not JSON, trying FormData');
            }
        }
        return origSend.call(this, body);
    };
})();

// ===========================
// Measurement Toggles
// ===========================
var measurementBottleSwitch = false;
var measurementCanSwitch = false;

function measurementBottleSwitcher() {
    measurementBottleSwitch = !measurementBottleSwitch;
    var bottleLink = document.getElementById('att-bottle');
    if (measurementBottleSwitch) {
        window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-yes');
        bottleLink.dataset.status = 'on';
        bottleLink.classList.add('ui-button-active');
    } else {
        window.expivi.setProductAttributeByKey('att-bottle', 'att-bottle-no');
        bottleLink.dataset.status = 'off';
        bottleLink.classList.remove('ui-button-active');
    }
}

function measurementCanSwitcher() {
    measurementCanSwitch = !measurementCanSwitch;
    var canLink = document.getElementById('att-can');
    if (measurementCanSwitch) {
        window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-yes');
        canLink.dataset.status = 'on';
        canLink.classList.add('ui-button-active');
    } else {
        window.expivi.setProductAttributeByKey('att-soda-can', 'att-soda-can-no');
        canLink.dataset.status = 'off';
        canLink.classList.remove('ui-button-active');
    }
}

// ===========================
// Price Container
// ===========================
function updatePriceContainer(priceText) {
    var el = document.getElementById('priceContainer');
    if (!el) return;
    if (priceText) { el.textContent = priceText; return; }
    if (el.textContent.trim()) return;
    try {
        var variants = window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
                       window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants;
        var cents = variants && variants[0] && variants[0].price;
        if (cents && cents > 0) {
            el.textContent = '$' + (cents / 100).toFixed(2) + ' - Add to Cart';
            return;
        }
    } catch (e) {}
    el.textContent = 'Add to Cart';
}

// ===========================
// Cart / Modal Guard
// ===========================
function cartOrModalOpen() {
    if (document.querySelector('.CartDrawer[aria-hidden="false"]')) return true;
    var sc = document.getElementById('slidecarthq');
    if (sc && sc.children.length > 0) return true;
    if (document.body.classList.contains('slidecart-open')) return true;
    if (document.body.classList.contains('cart-drawer-open')) return true;
    var lb = document.getElementById('xpv-info-lightbox');
    if (lb && lb.style.display === 'flex') return true;
    return false;
}

// ===========================
// Mobile Scroll Fix
// ===========================
function setOptionsHeight() {
    var viewerH = window.innerHeight * 0.44;
    var buttonsH = 80;
    var h = Math.max(120, window.innerHeight - viewerH - buttonsH);
    document.documentElement.style.setProperty('--xpv-options-h', Math.round(h) + 'px');
}

function injectScrollFixStyles() {
    var el = document.getElementById('xpv-scroll-fix-v3');
    if (!el) {
        el = document.createElement('style');
        el.id = 'xpv-scroll-fix-v3';
        document.head.appendChild(el);
    }
    el.textContent = [
        '@media (max-width: 600px) {',
        '  .xpv-app-container {',
        '    height: var(--xpv-options-h, calc(56vh - 80px)) !important;',
        '    max-height: var(--xpv-options-h, calc(56vh - 80px)) !important;',
        '    overflow-y: scroll !important;',
        '    -webkit-overflow-scrolling: touch !important;',
        '  }',
        '}'
    ].join('\n');
}

// ===========================
// Main DOMContentLoaded Code
// ===========================
document.addEventListener('DOMContentLoaded', function () {

    // --- Add to cart guard (per Expivi support) ---
    // Until the configurator has fully loaded and settled, the cached SKUs are
    // the catalogue defaults. Keep .expivi-add-to-cart disabled until
    // "fully_loaded" has fired and there were no further onChange events for
    // ET_SETTLE_MS, then re-read the SKUs and enable the button.
    var ET_SETTLE_MS = 800;
    var _etFullyLoaded = false;
    var _etSettled = false;
    var _etSettleTimer = null;

    var _etGuardStyle = document.createElement('style');
    _etGuardStyle.textContent = '.expivi-add-to-cart.expivi-atc-waiting{opacity:.5;cursor:not-allowed;}';
    document.head.appendChild(_etGuardStyle);

    function _etSetAtcDisabled(disabled) {
        document.querySelectorAll('.expivi-add-to-cart').forEach(function (btn) {
            btn.disabled = disabled;
            btn.classList.toggle('expivi-atc-waiting', disabled);
            btn.style.pointerEvents = disabled ? 'none' : '';
        });
    }

    var _etAtcObserver = new MutationObserver(function () {
        if (!_etSettled) _etSetAtcDisabled(true);
    });

    function _etArmSettleTimer() {
        clearTimeout(_etSettleTimer);
        _etSettleTimer = setTimeout(function () {
            window._etUpdateSkus().then(function () {
                window._etSnapshotBaselineSkus();
                _etSettled = true;
                _etAtcObserver.disconnect();
                _etSetAtcDisabled(false);
                console.log('[ET] Configurator settled, add to cart enabled.\n Selected SKUs:', window._etGetSelectedSkus());
            });
        }, ET_SETTLE_MS);
    }

    _etSetAtcDisabled(true);
    _etAtcObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
        if (!_etSettled && !_etFullyLoaded) {
            console.warn('[ET] fully_loaded not seen after 20s, enabling add to cart anyway');
            _etArmSettleTimer();
        }
    }, 20000);

    if (window.expivi) {
        window.expivi._events.onReady.subscribe(function () {
            window._etUpdateSkus();
        });
        window.expivi._events.onChange.subscribe(function (e) {
            if (e.name === 'attribute' || e.name === 'buildupdated') {
                window._etUpdateSkus().then(function () {
                    console.log('[ET] Selection changed (' + e.name + ')\n Selected SKUs:', window._etGetSelectedSkus());
                });
            }
            if (e.name !== 'frame') {
                if (e.name === 'fully_loaded') _etFullyLoaded = true;
                if (_etFullyLoaded && !_etSettled) _etArmSettleTimer();
            }
        });
        window.expivi.getProductAttributes().then(function (attrs) {
            var selections = attrs
                .filter(function (a) {
                    return a.type === 'question' && a.visible !== false
                        && a.attribute_values && a.attribute_values.length > 0;
                })
                .map(function (a) {
                    var sel = a.attribute_values.find(function (v) { return v.id === a.selected_value_id; });
                    if (!sel || !sel.key || sel.key === '-') return null;
                    return { Attribute: a.name, Selected: sel.name, Key: sel.key };
                })
                .filter(Boolean);
            console.log('[ET] Initial attribute selections:');
            console.table(selections);
        });
    }

    function updateProductSummary() {
        expivi.saveConfiguration().then((configData) => {
            var summaryDiv = document.getElementById('xpv-info-lightbox-content-1');
            var imageDiv = document.getElementById('xpv-info-lightbox-content-image');
            summaryDiv.innerHTML = '';
            imageDiv.innerHTML = '';
            var customParagraph = document.createElement('p');
            customParagraph.innerHTML = '<h3>Your Custom Bong!</h3>';
            summaryDiv.appendChild(customParagraph);
            var thumbnail = configData.configured_products[0].thumbnail;
            if (thumbnail) {
                var img = document.createElement('img');
                img.src = thumbnail;
                img.style.maxWidth = '100%';
                imageDiv.appendChild(img);
            }
            var ul = document.createElement('ul');
            configData.configured_products[0].attributes.forEach((a) => {
                var li = document.createElement('li');
                li.innerHTML = '<b>' + a.attribute_name + ':</b> ' + a.attribute_value_name;
                ul.appendChild(li);
            });
            summaryDiv.appendChild(ul);
        }).catch(ex => { console.error(ex); });
    }

    function showLightbox() {
        var lb = document.getElementById('xpv-info-lightbox');
        if (lb) lb.style.display = 'flex';
    }

    function hideLightbox() {
        var lb = document.getElementById('xpv-info-lightbox');
        if (lb) lb.style.display = 'none';
    }

    var summaryButton1 = document.getElementById('summaryLightbox');
    if (summaryButton1) {
        summaryButton1.addEventListener('click', function (e) {
            e.preventDefault();
            updateProductSummary();
            showLightbox();
        });
    }

    var summaryButton2 = document.getElementById('summaryLightbox2');
    if (summaryButton2) {
        summaryButton2.addEventListener('click', function (e) {
            e.preventDefault();
            updateProductSummary();
            showLightbox();
        });
    }

    var closeButton = document.getElementById('xpv-closeLightbox');
    if (closeButton) closeButton.addEventListener('click', hideLightbox);

    var lightboxOverlay = document.getElementById('xpv-info-lightbox');
    if (lightboxOverlay) {
        lightboxOverlay.addEventListener('click', function (e) {
            if (e.target === lightboxOverlay) hideLightbox();
        });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hideLightbox();
    });

    var infoLink = document.querySelector('.expivi-info-panel-right #expivi-info-panel-image a');
    if (infoLink) {
        infoLink.addEventListener('click', function (e) {
            e.preventDefault();
            var s = document.querySelector('.ProductSummary');
            if (s) s.scrollIntoView({ behavior: 'smooth' });
        });
    }

    var fullscreenButton = document.getElementById('button-fullscreen');
    if (fullscreenButton) {
        var fullscreenIcon = fullscreenButton.querySelector('i');
        var isFullscreen = false;
        fullscreenButton.addEventListener('click', function (e) {
            e.preventDefault();
            var viewer = document.querySelector('.expivi-viewer-container');
            var canvas = document.querySelector('#viewerContainer canvas');
            if (!viewer || !canvas) return;
            viewer.style.transition = 'height 0.8s ease, z-index 0s';
            canvas.style.transition = 'transform 0.8s ease, margin-top 0.8s ease';
            if (!isFullscreen) {
                viewer.style.height = '80vh';
                viewer.style.zIndex = '1002';
                canvas.style.transform = 'scale(2)';
                canvas.style.marginTop = '100px';
                fullscreenIcon.classList.remove('fa-expand');
                fullscreenIcon.classList.add('fa-compress');
            } else {
                viewer.style.height = '';
                viewer.style.zIndex = '';
                canvas.style.transform = '';
                canvas.style.marginTop = '';
                fullscreenIcon.classList.remove('fa-compress');
                fullscreenIcon.classList.add('fa-expand');
            }
            isFullscreen = !isFullscreen;
        });
    }

    var bottleLink = document.getElementById('att-bottle');
    if (bottleLink) {
        bottleLink.addEventListener('click', function (e) {
            e.preventDefault();
            measurementBottleSwitcher();
        });
    }

    var canLink = document.getElementById('att-can');
    if (canLink) {
        canLink.addEventListener('click', function (e) {
            e.preventDefault();
            measurementCanSwitcher();
        });
    }

    var icon = document.getElementById('interactive-icon');
    var panelButton = document.getElementById('expivi-info-panel-button');
    if (icon && panelButton) {
        icon.addEventListener('click', function (e) {
            e.preventDefault();
            if (panelButton.classList.contains('expanded')) {
                panelButton.style.width = '36px';
                setTimeout(function () { panelButton.classList.remove('expanded'); }, 300);
            } else {
                panelButton.classList.add('expanded');
                panelButton.style.width = '180px';
            }
        });
    }

    var embeddedAddToCartBtn = document.getElementById('embedded-add-to-cart-btn');
    if (embeddedAddToCartBtn) {
        var _etOriginalLabel = embeddedAddToCartBtn.innerHTML;
        var _etResetTimer = null;
        var _etUnsubscribe = null;

        var _etResetAddToCartButton = function (reason) {
            if (_etResetTimer) { clearTimeout(_etResetTimer); _etResetTimer = null; }
            if (typeof _etUnsubscribe === 'function') { _etUnsubscribe(); _etUnsubscribe = null; }
            embeddedAddToCartBtn.innerHTML = _etOriginalLabel;
            embeddedAddToCartBtn.disabled = false;
            if (reason) console.warn('[ET] Add to cart button reset:', reason);
        };

        embeddedAddToCartBtn.addEventListener('click', function () {
            embeddedAddToCartBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Adding to cart...';
            setTimeout(hideLightbox, 400);

            // Reset the label once the cart actually confirms the change.
            if (window.weNexusCartApi && typeof window.weNexusCartApi.addListener === 'function') {
                if (typeof _etUnsubscribe === 'function') { _etUnsubscribe(); _etUnsubscribe = null; }
                _etUnsubscribe = window.weNexusCartApi.addListener(function () {
                    _etResetAddToCartButton();
                });
            }

            // Fallback: never leave the button stuck on "Adding to cart..." forever.
            if (_etResetTimer) clearTimeout(_etResetTimer);
            _etResetTimer = setTimeout(function () {
                _etResetAddToCartButton('no cart confirmation within 15s');
            }, 15000);
        });
    }

    if (window.expivi) window.expivi._events.onChange.subscribe(async function (e) {
        if (e.name === 'fully_loaded') {
            try {
                var result = await window.expivi.saveConfiguration(0, 0, false, false, { include_keys: true });
                var attributes = result.configured_products[0].configuration.attributes;
                var bLink = document.getElementById('att-bottle');
                var cLink = document.getElementById('att-can');
                if (bLink && cLink) {
                    var bVal = attributes.filter(function (a) { return a.attribute_key === 'att-bottle'; }).map(function (a) { return a.attribute_value_name; })[0];
                    var cVal = attributes.filter(function (a) { return a.attribute_key === 'att-soda-can'; }).map(function (a) { return a.attribute_value_name; })[0];
                    if (bVal === 'Yes') { bLink.dataset.status = 'on'; bLink.classList.add('ui-button-active'); measurementBottleSwitch = true; }
                    else { bLink.dataset.status = 'off'; bLink.classList.remove('ui-button-active'); measurementBottleSwitch = false; }
                    if (cVal === 'Yes') { cLink.dataset.status = 'on'; cLink.classList.add('ui-button-active'); measurementCanSwitch = true; }
                    else { cLink.dataset.status = 'off'; cLink.classList.remove('ui-button-active'); measurementCanSwitch = false; }
                }
            } catch (ex) { console.error('Error retrieving attribute:', ex); }
            updatePriceContainer();
        }
    });

    if (window.innerWidth <= 600) {
        setOptionsHeight();
        injectScrollFixStyles();
        window.addEventListener('resize', setOptionsHeight);
        window.addEventListener('orientationchange', function () { setTimeout(setOptionsHeight, 200); });

        new MutationObserver(function () {
            if (cartOrModalOpen()) return;
            if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
        }).observe(document.body, { attributes: true, attributeFilter: ['style'] });

        document.addEventListener('touchend', function () {
            if (cartOrModalOpen()) return;
            if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
        }, { passive: true });
    }

    updatePriceContainer();

});
